import { Typography } from 'antd';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import { EditFilled } from '@ant-design/icons';
import { cargoAction } from '@/utils/googleMapUtils';

const DetailItem = ({
  label,
  detail,
  multiline = false,
  isCopy = false,
  customClass,
  customLabelClass,
  customMainClass,
  isEdit,
  onEdit,
  numberPlate,
  isMap,
  lat,
  lng,
}: {
  label: string;
  detail: React.ReactNode;
  multiline?: boolean;
  isCopy?: boolean;
  customClass?: string;
  customLabelClass?: string;
  customMainClass?: string;
  isEdit?: boolean;
  onEdit?: () => void;
  isLink?: boolean;
  isMap?: boolean;
  numberPlate?: string;
  lat?: string;
  lng?: string;
}) => {
  const onCargo = async (numberPlate: string, lat?: string, lng?: string) => {
    await cargoAction(numberPlate, lat, lng);
  };

  return (
    <div
      className={twMerge(
        'flex flex-col gap-2 md:flex-row items-start',
        customMainClass,
      )}
    >
      <div
        className={twMerge(
          'text-base font-bold min-w-[80px] md:min-w-[160px]',
          customLabelClass,
        )}
      >
        {label}
      </div>
      <div
        className={twMerge(
          'text-base text-gray-600 break-words overflow-hidden',
          multiline && 'min-h-[48px]',
          customClass,
          isMap && 'underline text-blue-700 underline-offset-2 cursor-pointer',
        )}
      >
        {isMap ? (
          <div onClick={() => onCargo(numberPlate || '', lat, lng)}>
            {detail}
          </div>
        ) : (
          detail || ''
        )}
        {isCopy && (
          <Typography.Text
            className="pl-1"
            copyable={{ text: detail as string }}
          />
        )}
        {isEdit && (
          <EditFilled
            className="text-red-500 pl-1"
            onClick={() => onEdit && onEdit()}
          />
        )}
      </div>
    </div>
  );
};

export { DetailItem };
